module.exports = __webpack_public_path__ + "static/media/message-bg.345fb6ed.png";